import { StudentWellbeingHubCard } from "src/Views/Home/components/StudentWellbeingHubCard/StudentWellbeingHubCard";

export default function ComponentsStudentHub() {
  return (
    <div className="space-y-8">
      <div className="w-full mx-auto max-w-[400px]">
        <StudentWellbeingHubCard />
      </div>
    </div>
  );
}
